import { useMemo, useState } from "react";
import { Sparkles } from "lucide-react";

export const efectosDe = (c) => {
  if (!c || c.error) return [];
  const e = [];
  const cod = c.codigo;
  if (cod >= 95) e.push("tormenta");
  if (c.lloviendo) e.push((c.precip_mm || 0) >= 4 || [65, 82].includes(cod) ? "lluvia-fuerte" : "lluvia");
  else if ((c.nubes_pct ?? 0) >= 60 || [3, 45, 48].includes(cod)) e.push("nublado");
  if ((c.viento_kmh || 0) >= 25 || (c.rafagas_kmh || 0) >= 40) e.push("viento");
  if ((c.temp_c || 0) >= 33) e.push("calor");
  if (cod === 45 || cod === 48) e.push("niebla");
  return e;
};
const ETQ = { tormenta: "Tormenta", lluvia: "Lluvia", "lluvia-fuerte": "Lluvia fuerte", nublado: "Nublado", viento: "Viento fuerte", calor: "Calor intenso", niebla: "Niebla" };

const Gotas = ({ n, fuerte }) => {
  const g = useMemo(() => Array.from({ length: n }, () => ({ l: Math.random() * 100, d: Math.random() * 1.2, t: (fuerte ? 0.45 : 0.75) + Math.random() * 0.4, o: 0.35 + Math.random() * 0.5 })), [n, fuerte]);
  return <div className="ec-capa ec-lluvia">{g.map((x, i) => <i key={i} style={{ left: `${x.l}%`, animationDelay: `-${x.d}s`, animationDuration: `${x.t}s`, opacity: x.o }} />)}</div>;
};
const Rafagas = () => <div className="ec-capa ec-viento">{Array.from({ length: 14 }, (_, i) => <i key={i} style={{ top: `${(i * 7.1) % 100}%`, animationDelay: `-${(i * 0.37) % 3}s`, width: `${80 + ((i * 53) % 160)}px` }} />)}</div>;

export function EfectoClima({ c }) {
  const [on, setOn] = useState(true);
  const ef = efectosDe(c);
  if (!ef.length) return null;
  return <>
    {on && <div className="ec-root" aria-hidden data-testid="efecto-clima">
      {ef.includes("nublado") && <div className="ec-capa ec-nubes" />}
      {ef.includes("niebla") && <div className="ec-capa ec-niebla" />}
      {ef.includes("calor") && <div className="ec-capa ec-calor" />}
      {(ef.includes("lluvia") || ef.includes("lluvia-fuerte")) && <><div className="ec-capa ec-oscuro" /><Gotas n={ef.includes("lluvia-fuerte") ? 140 : 70} fuerte={ef.includes("lluvia-fuerte")} /></>}
      {ef.includes("tormenta") && <div className="ec-capa ec-rayo" />}
      {ef.includes("viento") && <Rafagas />}
    </div>}
    <button onClick={() => setOn(!on)} className="ec-btn" data-testid="efecto-clima-toggle" title="Efecto visual según el clima actual de la zona">
      <Sparkles className="w-3.5 h-3.5" /><span data-testid="efecto-clima-etiqueta">{ef.map((k) => ETQ[k]).join(" · ")}</span><span className="opacity-70">{on ? "· ocultar" : "· mostrar"}</span>
    </button>
  </>;
}
